import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ title, value, icon, iconColor, subtitle, loading }) => (
  <div className="bg-[#1A1A1A] rounded-xl border border-white/8 p-4 shadow-sm hover:border-white/15 transition-all duration-200 flex flex-col justify-between min-h-[100px]">
    <div className="flex items-start justify-between mb-2">
      <span className="text-xs font-oranienbaum text-white/50 leading-tight pr-2">{title}</span>
      <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: `${iconColor}18` }}>
        <Icon name={icon} size={15} style={{ color: iconColor }} />
      </div>
    </div>
    {loading ? (
      <div className="h-6 w-16 bg-white/5 rounded animate-pulse" />
    ) : (
      <p className="text-xl font-bold font-oranienbaum leading-tight text-white">{value}</p>
    )}
    {subtitle && <p className="text-[10px] font-oranienbaum text-white/35 mt-1 truncate">{subtitle}</p>}
  </div>
);

const EventoKPICards = ({ eventos, loading }) => {
  const today = new Date()?.toISOString()?.split('T')?.[0];
  const now = new Date();
  const startOfWeek = new Date(now);
  startOfWeek?.setDate(now?.getDate() - now?.getDay() + 1);
  const endOfWeek = new Date(startOfWeek);
  endOfWeek?.setDate(startOfWeek?.getDate() + 6);
  const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1)?.toISOString()?.split('T')?.[0];
  const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0)?.toISOString()?.split('T')?.[0];
  const startOfWeekStr = startOfWeek?.toISOString()?.split('T')?.[0];
  const endOfWeekStr = endOfWeek?.toISOString()?.split('T')?.[0];

  const eventosHoy = eventos?.filter(e => e?.fecha === today)?.length || 0;
  const eventosSemana = eventos?.filter(e => e?.fecha >= startOfWeekStr && e?.fecha <= endOfWeekStr)?.length || 0;
  const eventosMes = eventos?.filter(e => e?.fecha >= startOfMonth && e?.fecha <= endOfMonth)?.length || 0;
  const pendientes = eventos?.filter(e => e?.estado === 'PROGRAMADO' || e?.estado === 'Pendiente')?.length || 0;
  const confirmados = eventos?.filter(e => e?.estado === 'REALIZADO' || e?.estado === 'Confirmado')?.length || 0;
  const completados = eventos?.filter(e => e?.estado === 'REALIZADO' || e?.estado === 'Finalizado')?.length || 0;
  const facturacionPrevista = eventos?.reduce((sum, e) => sum + (parseFloat(e?.precioServicio) || 0), 0);
  const kgPlanificados = eventos?.reduce((sum, e) => sum + (parseFloat(e?.numPiezas) || 0), 0);

  const kpis = [
    { title: 'Eventos Hoy', value: eventosHoy, icon: 'CalendarCheck', iconColor: '#D6EF4E', subtitle: 'Programados para hoy' },
    { title: 'Eventos Semana', value: eventosSemana, icon: 'CalendarDays', iconColor: '#3A7F6B', subtitle: 'Esta semana' },
    { title: 'Eventos Mes', value: eventosMes, icon: 'Calendar', iconColor: '#C9A24D', subtitle: 'Este mes' },
    { title: 'Servicios Pendientes', value: pendientes, icon: 'Clock', iconColor: '#C9A24D', subtitle: 'Por confirmar' },
    { title: 'Confirmados', value: confirmados, icon: 'CheckCircle', iconColor: '#3A7F6B', subtitle: 'Eventos confirmados' },
    { title: 'Completados', value: completados, icon: 'CheckSquare', iconColor: '#3A7F6B', subtitle: 'Finalizados' },
    { title: 'Facturación Prevista', value: `${facturacionPrevista?.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} €`, icon: 'Euro', iconColor: '#D6EF4E', subtitle: 'Total previsto' },
    { title: 'Kg Planificados', value: `${kgPlanificados?.toLocaleString('es-ES')} kg`, icon: 'Package', iconColor: '#8B5CF6', subtitle: 'Piezas planificadas' },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
      {kpis?.map((kpi, i) => (
        <KPICard key={i} {...kpi} loading={loading} />
      ))}
    </div>
  );
};

export default EventoKPICards;
